export default {
  app: {
    title: 'Todo 앱',
    loading: '로딩 중...',
    error: '오류가 발생했습니다',
    success: '성공했습니다',
  },
  button: {
    save: '저장',
    cancel: '취소',
    delete: '삭제',
    edit: '수정',
    add: '추가',
    confirm: '확인',
    close: '닫기',
  },
  validation: {
    required: '필수 항목입니다',
    email: '올바른 이메일을 입력하세요',
    minLength: '{{min}}자 이상 입력하세요',
    maxLength: '{{max}}자 이하로 입력하세요',
  },
}

